import React from 'react'

export default function paymentGateway() {
    return (
        <div>paymentGateway</div>
    )
}
